import React, { Component } from 'react'
import $ from 'jquery';

class Mobilemenu extends Component{

    componentDidMount = () => {
        const auxheader = $("#aux-header");
        const navheader = $(".nav-header");
        //handling mobile page resize and mobile menu

        $( document ).ready(function() {
            // console.log( "ready! Mobile Menu" );
            //$(".mobile-toggle").addClass("")
            if (window.innerWidth < 768){
                $(".mobile-toggle").toggle(!0)
            }
        });

        $(window).resize(function() {
            if (window.innerWidth < 768){
                auxheader.addClass("mobile");
                navheader.css('top', '60px')
                $(".mobile-toggle").toggle(!0);
            }else{
                //alert("resize please")
                auxheader.removeClass("mobile")
                navheader.css('top', '60px')
                $(".mobile-toggle").toggle(1)
                $("#mobile-nav").removeClass("open")
                $(".mobile-toggle").removeClass("open")
            }

        });

        $(".mobile-toggle").on("click", function(e) {
            //$(".mobile-toggle").toggle(!0)
            e.preventDefault()
            auxheader.addClass("mobile")
            $(".mobile-toggle").toggleClass("open")
            $("#mobile-nav").toggleClass("open")
            //$("#mobile-nav").addClass("open")
            //$(".mobile-toggle").toggle(1)
            //$("body").toggleClass("modal-open")
        });

        $(".mobile-nav__title").on("click", function(e) {
            e.preventDefault()
            $(this).toggleClass("mobile-nav__title--close")
            $(this).next(".mobile-nav__lists").toggleClass("mobile-nav__lists--close")
        });
    }

    render(){
        return(
            <React.Fragment></React.Fragment>
        );
    }
}

export default Mobilemenu;
